import { Component } from '@angular/core';

@Component({
  selector: 'app-analisis-de-riesgos-y-oportunidades',
  templateUrl: './analisis-de-riesgos-y-oportunidades.component.html',
  styleUrls: ['./analisis-de-riesgos-y-oportunidades.component.css']
})
export class AnalisisDeRiesgosYOportunidadesComponent {

}
